/**
 * Types + fetcher for GET /api/v1/auth/config — the anonymous discovery
 * endpoint the SPA hits at boot to learn its Entra configuration.
 *
 * Types come from the OpenAPI-generated schema. Regenerate via
 * `pnpm gen:api` after a backend Pydantic change.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type AuthConfig = components["schemas"]["AuthConfigOut"];

export function getAuthConfig(): Promise<AuthConfig> {
  // Anonymous endpoint — no token.
  return apiFetch<AuthConfig>("/api/v1/auth/config");
}
